import { RootState } from '@/plugins/store';
import { Module } from 'vuex';
import { actions } from './actions';
import { mutations } from './mutations';
import state, { EquipementInterventionsState } from './state';
import { getters } from './getters';

const module: Module<EquipementInterventionsState, RootState> = {
    state,
    actions,
    mutations,
    getters,
};

export default module;
export type { EquipementInterventionsState };
